import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      label: 'Webhook Events',
      value: stats?.totalWebhookEvents || 0,
      icon: 'Webhook',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Edge Function Logs',
      value: stats?.totalLogs || 0,
      icon: 'FileText',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'JWT Failures',
      value: stats?.totalJwtFailures || 0,
      icon: 'ShieldAlert',
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {statCards?.map((stat) => (
        <div key={stat?.label} className="bg-card border border-border rounded-lg p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-3xl font-bold text-foreground">{stat?.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;